/**
 * 好友详情页懒加载壳（14.21b；ContactApplyLazy 同构）：低频页不进首屏 bundle。
 */
import { useLazyModule } from './useLazyModule';

export function FriendDetailLazy({ friendId }: { friendId: number }) {
  const { mod } = useLazyModule(() => import('./FriendDetailPage'));
  if (mod === null) return <div data-testid="friend-detail-loading-shell">加载中…</div>;
  return <mod.FriendDetailPage friendId={friendId} />;
}
